// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/fatture/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","sedeId":"number|null","nominativoId":"number|null","commessaId":"number|null","tipoFattura":"IMMEDIATA|DIFFERITA","stato":"BOZZA|EMESSA|ANNULLATA","numero":"string|null","dataDocumento":"string|null","dataEmissione":"string|null","note":"string|null","totaleImponibile":"number","totaleIva":"number","totale":"number","clienteRagioneSociale":"string|null","clienteNome":"string|null","clienteCognome":"string|null","clientePartitaIva":"string|null","clienteCodiceFiscale":"string|null","clienteIndirizzo":"string|null","clienteCap":"string|null","clienteCitta":"string|null","clienteProvincia":"string|null","clienteEmail":"string|null","clienteTelefono":"string|null","commessa":{"id":"number","numero":"string","descrizione":"string"},"tipoDocumento":{"id":"number","codice":"string","nome":"string"},"condizionePagamento":{"id":"number","nome":"string"},"createdBy":{"id":"number","nome":"string"},"annullataDa":{"id":"number","nome":"string"},"righe":[{"id":"number","ordinePos":"number","tipoRiga":"DDT|SAL|ACCONTO|STORNO_ACCONTO|DESCRITTIVA","descrizione":"string","umVendita":"string|null","quantita":"number|null","prezzoUnitario":"number|null","imponibile":"number","aliquotaIvaFreeze":"number|null","iva":"number","riferimento":"string|null","ddt":{"id":"number","numero":"string"},"sal":{"id":"number","numero":"string"},"proformaAcconto":{"id":"number","numero":"string"},"codiceIva":{"id":"number","codice":"string","aliquota":"number"}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/tipi-documento?societaId=&famiglia=FATTURA&soloAttivi=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/pagamenti?societaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}],"condizioni":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/:id/emetti',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSA","numero":"string","dataEmissione":"string","warning":"string|null"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/:id/annulla',
    requestBody: '{"motivo":"string?"}',
    response: '{"success":true,"data":{"stato":"ANNULLATA"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/fatture/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/fatture/:id',
    requestBody: '{"dataDocumento":"string|null","condizionePagamentoId":"number|null","note":"string|null","tipoDocumentoId":"number|null"}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
